function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 4a1 1 0 012 0v4a1 1 0 01-2 0V4z",
  fill: "url(#promptness_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 4a1 1 0 112 0v4a1 1 0 11-2 0V4z",
  fill: "url(#promptness_svg__paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 4a1 1 0 112 0v4a1 1 0 11-2 0V4z",
  fill: "url(#promptness_svg__paint2_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 4a1 1 0 112 0v4a1 1 0 11-2 0V4z",
  fill: "url(#promptness_svg__paint3_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.5 6a.5.5 0 01.5.5V8a2 2 0 104 0V6.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V8a2 2 0 104 0V6.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V8a2 2 0 104 0V6.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V8a2 2 0 104 0V6.5a.5.5 0 01.5-.5h.5a2 2 0 012 2v20a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h.5zM6 13a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1H6zm0 8a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1H6zm7-7a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4zm1 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-4zm7-7a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4zm1 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-4z"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "promptness_svg__paint0_linear",
  x1: 6.375,
  y1: 3,
  x2: 8.008,
  y2: 3.124,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "promptness_svg__paint1_linear",
  x1: 24.375,
  y1: 3,
  x2: 26.008,
  y2: 3.124,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "promptness_svg__paint2_linear",
  x1: 12.375,
  y1: 3,
  x2: 14.008,
  y2: 3.124,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "promptness_svg__paint3_linear",
  x1: 18.375,
  y1: 3,
  x2: 20.008,
  y2: 3.124,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgPromptness = function SvgPromptness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgPromptness;